<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
      </b-col>
      <b-col lg="6" class="text-right">
        <a href="https://twitter.com/raul__cano" target="_blank">Twitter</a> | 
        <a href="https://github.com/raulcano/bitcoinminds" target="_blank">GitHub</a> | 
        <a href="http://www.theknowledgeargument.com/" target="_blank">Blog</a> | 
        <a href="#/licenses">Licenses, credits and attributions</a>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
    };
  }
};
</script>
<style></style>
